import { Col, Row } from "antd";
import { getLevelColor } from "../../utils";
import { useTranslation } from "react-i18next";

type Props = {
  score?: number;
  level?: string;
};

export function SupplierEvaluationGrade({ score, level }: Props) {
  const { t } = useTranslation("supplierPerformance");

  if (!score || !level) return null;

  const fontColor = getLevelColor(score);
  return (
    <Row gutter={[16, 8]}>
      <Col span={24}>
        <span>{t("考核得分")}：</span>
        <span style={{ color: fontColor }}>
          {score}
          {t("分")}
        </span>
      </Col>
      <Col span={24}>
        <span>{t("绩效级别")}：</span>
        <span style={{ color: fontColor }}>{level}</span>
      </Col>
    </Row>
  );
}
